// ============================================================
// Switch.js
// iOS-style toggle. Controlled component — caller owns the
// boolean state and the change handler.
//
// Renders a native <button role="switch"> for accessibility:
// screen readers announce "switch, on" / "switch, off", and
// keyboard activation (Space / Enter) flips it via the same
// onChange path as a click.
//
// Disabled state suppresses both visual hover and click handler.
// ============================================================

import React from 'react';
import './Switch.css';

export default function Switch({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  ariaLabelledBy,
  id,
}) {
  function handleClick() {
    if (disabled) return;
    onChange(!checked);
  }

  const cls = [
    'switch',
    checked ? 'switch--on' : 'switch--off',
    disabled ? 'switch--disabled' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      disabled={disabled}
      className={cls}
      onClick={handleClick}
    >
      <span className="switch__thumb" aria-hidden="true" />
    </button>
  );
}
